export default __webpack_public_path__ + "static/media/nhlFantasyPWRSDark.843c381d.png";